/**
 * RatingContainer component.
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

/**
 * Styled rating container.
 */
const RatingContainer = styled.div`
  align-items: center;
  display: flex;
  margin-right: ${4 * Screen.widthRatio}px;
`;

export default RatingContainer;
